import React from "react";
import "./cardscontainer.css";

const CardsContainer = ({ heading,subheading, services, paragraph, className }) => {
  return (
    <div>
      <div className={`plethora-of-services ${className}`}>
        <h2
          className={`plethora-heading ${paragraph ? "mb-16px" : "mb-40px"
            }`} >
          {heading}
        </h2>

         {subheading && (
          <h4 className="plethora-subheading ">{subheading}</h4>
        )}


        {paragraph && <p className="plethora-paragraph us-apart-p2">{paragraph}</p>}
        <div className="plethora-grid">
          {services.map((service, index) => (
            <div className="plethora-card" key={index}>
              <img src={service.img} alt={service.title} />
              <h3>{service.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardsContainer;
